import React from 'react';
import { Link as RRLink } from 'react-router-dom';
import { Link, Typography } from '@mui/material';
import { capitalize } from 'inflection';

const ReviewLink = (props: { model: string; id: number }) => {
  const model = props?.model;
  const id = props?.id;

  if (!id) {
    return null;
  }

  return (
    <Link component={RRLink} to={`/${model}/${id}/show`}>
      <Typography>
        {capitalize(model)}: {id}
      </Typography>
    </Link>
  );
};

export default ReviewLink;
